const HOW_WE_WORK_TITLE = 'Почему нам доверяют';
const ACTION_BUTTON_TEXT = 'Написать отзыв';
const LINK_HOW_WE_WORK = '/document/review-rules/';
const TEXT_BUTTON_HOW_WE_WORK = 'Подробнее';
const DESCRIPTION_RATED = 'Спасибо! Дополните оценку отзывом, чтобы ее\u00A0опубликовать';
const DESCRIPTION_UNRATED = 'Оцените свой опыт или решите проблему у\u00A0нас на\u00A0сайте';
const HEADER_FORM = 'Оставьте отзыв';

export { ACTION_BUTTON_TEXT, DESCRIPTION_RATED, DESCRIPTION_UNRATED, HEADER_FORM, HOW_WE_WORK_TITLE, LINK_HOW_WE_WORK, TEXT_BUTTON_HOW_WE_WORK };
//# sourceMappingURL=components.js.map
